import { createFileRoute } from "@tanstack/react-router";
import Workflows from "../../../../../views/staff/Workflows";

export const Route = createFileRoute("/_authenticated/user/staff/workflows/$workflow_id")({
  component: Workflows,
});
